import React from 'react';
import PropTypes from 'prop-types';

function CardContent(props) {
  const { classes, className, component: ComponentProp, ...other } = props;
  const Component = ComponentProp || 'div';

  return <Component className={className} {...other} />;
}

CardContent.propTypes = {
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const CardContent = ({prop = val, component = 'div', className = '' }) =>

export default CardContent;
